<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      Юпитер
    </v-card-title>
    <v-card-text>
      <v-switch
        :input-value="localValue"
        :label="localValue ? 'Синхронизация с Юпитером включена' : 'Синхронизация с Юпитером отключена'"
        :disabled="saving || locked"
        hide-details
        @change="onToggle"
      />

      <p v-if="locked" class="grey--text mt-3 mb-0">
        Филиал подключён к ФАКТ — синхронизацию обратно не включить.
      </p>
    </v-card-text>

    <primary-confirm-dialog
      v-model="showDialog"
      :title="pendingValue ? 'Включить синхронизацию с Юпитером?' : 'Отключить филиал от Юпитера?'"
      :loading="saving"
      @confirm="apply"
      @cancel="onCancel"
    >
      <template #subtitle>
        {{ pendingValue
          ? 'Заказы и бонусы филиала снова поедут в Юпитер.'
          : 'Филиал перестанет обмениваться заказами, стоп-листами и бонусами с Юпитером.' }}
      </template>
    </primary-confirm-dialog>
  </v-card>
</template>

<script>
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import filialConnectionApi from '@/api/administration/filialConnection'

  export default {
    name: 'FilialConnectionJupiterBlock',
    components: { PrimaryConfirmDialog },
    mixins: [snackbarMessage],
    props: {
      filialId: { type: [Number, String], required: true },
      value: { type: Boolean, default: false },
      filialConnected: { type: Boolean, default: false },
    },
    data () {
      return {
        localValue: this.value,
        showDialog: false,
        saving: false,
        pendingValue: false,
      }
    },
    computed: {
      // Отключение необратимо: после подключения к ФАКТ заказы живут здесь
      locked () {
        return this.filialConnected && !this.localValue
      },
    },
    watch: {
      value (val) {
        this.localValue = val
      },
    },
    methods: {
      onToggle (next) {
        this.pendingValue = Boolean(next)
        this.localValue = this.pendingValue
        this.showDialog = true
      },
      // v-switch держит своё состояние и следит за пропом: вернуть тумблер
      // на место можно только сменой значения, а не перезагрузкой сводки
      revert () {
        this.localValue = !this.pendingValue
      },
      onCancel () {
        this.revert()
      },
      async apply () {
        this.saving = true
        try {
          await filialConnectionApi.setJupiterSync(this.filialId, this.pendingValue)
          this.showSuccessMessage(this.pendingValue ? 'Юпитер включён' : 'Юпитер отключён')
        } catch (e) {
          this.showErrorFromResponse(e)
          this.revert()
        }
        this.saving = false
        this.showDialog = false
        this.$emit('updated')
      },
    },
  }
</script>
